<template>
<b-form @submit="onSubmit">
    <b-row class="no-gutters m-2 OTsectionHeader" >
        <b-col cols="12" md="6" >
            <h1>Seed URLs</h1>
            <p>
                Enter in the URLs you want to start crawling from. The web crawler will find all links within the URL and start crawling those as well. To control
                which urls are crawled, use the <strong>crawling filters</strong>. If you want to control which URLs you grab content from, use the <strong>ingestion filters</strong>.
            </p>
        </b-col>
        <b-col class="text-right OTbtnContainer" cols="12" md="6">
            <b-button type="button" variant=" OTSecondary" @click="$router.push({name: 'jobs'})">Cancel</b-button>
            <b-button type="submit" variant=" OTPrimary">Save</b-button>
        </b-col>
    </b-row>
    <b-row>
        <b-col class="no-gutters mt-2 mr-2">
            <otif-draggableList  class="OTdraglist" v-model="urls" :preInput="enforceScheme" @add="onAddUrl"></otif-draggableList>
        </b-col>
    </b-row>
</b-form>
</template>

<script>

import { resourceMapper } from '@/utils/resourceMapper.js';

export default {
    props: ['job'],
    computed: {
        ...resourceMapper([{
            propertyName: 'urls',
            attributeName: 'job_criteria.urls'
        }], 'job', 'url-management')
    },

    methods: {
        enforceScheme(value) {
            if (!value) {
                return;
            }
            if (!value.startsWith('http://') && !value.startsWith('https://')) {

                value = 'http://' + value;
            }
            return value;
        },

        onSubmit($e) {
            $e.preventDefault();
            this.job.save();
        },

        onAddUrl(url) {
            if (!this.job.get('job_criteria.url_filters')) {
                this.job.set('job_criteria.url_filters', []);
            }

            const filters = this.job.get('job_criteria.url_filters');

            if (filters.length === 0) {
                filters.push({
                    type: 'INCLUDE',
                    expression: url + '*'
                });

                filters.push({
                    type: 'EXCLUDE',
                    expression: '.'
                });
            } else {
                filters.splice(filters.length-2, 0, {
                    type: 'INCLUDE',
                    expression: url + '*'
                });
            }

            this.job.set('job_criteria.url_filters', filters);
        }
    }
}
</script>
